import { Link } from "react-router-dom";
import { ArrowUpRight, MapPin, Calendar, Ruler } from "lucide-react";
import { REFERENCES } from "@/data/content";

export default function References({ limit = 6 }) {
  const items = REFERENCES.slice(0, limit);
  return (
    <section className="bg-white" data-testid="references-section">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 lg:px-16 py-24 md:py-32">
        <div className="flex flex-col md:flex-row items-start md:items-end justify-between gap-6 mb-14">
          <div className="max-w-2xl">
            <p className="text-xs font-bold uppercase tracking-[0.25em] text-[#2873B8] mb-4">Referenzen</p>
            <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-[#0C2749]" style={{ fontFamily: "Outfit" }}>
              Projekte, die wir realisiert haben.
            </h2>
          </div>
          <Link to="/referenzen" className="inline-flex items-center gap-2 text-sm font-medium text-[#0C2749] hover:text-[#2873B8] group" data-testid="references-all-link">
            Alle Referenzen <ArrowUpRight className="w-4 h-4 group-hover:rotate-45 transition-transform" />
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {items.map((r) => (
            <article
              key={r.id}
              data-testid={`reference-card-${r.id}`}
              className="group bg-white border border-slate-100 hover:border-[#2873B8] hover:shadow-lg shadow-[#0C2749]/5 transition-all"
            >
              <div className="relative aspect-[4/3] overflow-hidden">
                <img src={r.image} alt={r.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" loading="lazy" />
                <div className="absolute top-4 left-4 bg-white text-[#0C2749] text-xs font-semibold px-3 py-1.5 uppercase tracking-wider">
                  {r.type}
                </div>
              </div>
              <div className="p-6 md:p-8">
                <h3 className="text-xl font-semibold text-[#0C2749] mb-2" style={{ fontFamily: "Outfit" }}>{r.title}</h3>
                <p className="text-sm text-slate-600 mb-4 line-clamp-2">{r.description}</p>
                <div className="flex flex-wrap gap-x-5 gap-y-2 text-xs text-slate-500">
                  <span className="inline-flex items-center gap-1.5"><MapPin className="w-3.5 h-3.5" /> {r.location}</span>
                  <span className="inline-flex items-center gap-1.5"><Ruler className="w-3.5 h-3.5" /> {r.size}</span>
                  <span className="inline-flex items-center gap-1.5"><Calendar className="w-3.5 h-3.5" /> {r.duration} · {r.year}</span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
